const tags = (data) => {
    let resultsHTML = ''
    if (data.tags) {
        data.tags.map((service) => {
            resultsHTML += `
                <span class="tag tag--cornflower tag--shape-curved">
                    ${service}
                </span>
            `
        })
    }
    return resultsHTML
}

const image = (data) => {
    if (data.logoSrc) {
        return `<figure class="card__main-media">
            <div class="card__main-img" style="background-image: url(${data.logoSrc}); background-position: center center; background-repeat: no-repeat; background-size: contain;"></div>
            </figure>`
    } else {
        return ''
    }
}

// prettier-ignore
const template = (data, extraClass = '') => {

    return `<div class="grid__item">
        <a href="${data.link}" class="card card--logo ${extraClass} card--link">
            <article class="card__body">
                <div class="card__main grid--justify-end">
                    ${image(data)}
                    <div class="card__header u-mb0">
                        <div class="tags">
                            ${tags(data)}
                        </div>
                        <h3 class="card__heading">
                        ${data.name}
                        </h3>
                    </div>
                    ${data.location !== null ? `<div class="card__copy"><p>${data.location}</p></div>` : ''}
                </div>
            </article>
        </a>
    </div>`
}
export default template
